import { create } from '@thoughtspot/logger';
import { Alert, } from '@thoughtspot/radiant-react/widgets/alert';
import React, { createContext, useEffect, useReducer } from 'react';
import ReactDOM from 'react-dom';
import { Action, GLOBAL_ALERT_CONTAINER_ID, GlobalAlertTestId, initialState, V1_GLOBAL_ALERT_CONTAINER_ID, } from './global-alert-context.util';
export const GlobalAlertContext = createContext(null);
const logger = create('Global alert context');
export const reducer = (state, action) => {
    switch (action.type) {
        case Action.UPDATE_BANNER: {
            if (state.currentBannerId !== action.id &&
                action.alertProps.isVisible !== true) {
                return state;
            }
            return {
                ...state,
                bannerAlertProps: action.alertProps,
                currentBannerId: action.alertProps.isVisible ? action.id : null,
            };
        }
        case Action.UPDATE_TOAST:
            return {
                ...state,
                toastAlertProps: action.alertProps,
                currentToastId: action.id,
            };
        default:
            return state;
    }
};
export const GlobalAlertContextProvider = ({ children, customBannerAlertContainerId, }) => {
    const [state, dispatch] = useReducer(reducer, initialState);
    const updateBannerAlert = (id, alertProps) => {
        if (state.currentBannerId && id !== state.currentBannerId) {
            if (alertProps.isVisible) {
                state.bannerAlertProps.onClose();
            }
            else {
                return;
            }
        }
        dispatch({
            type: Action.UPDATE_BANNER,
            alertProps: { ...alertProps, global: true },
            id,
        });
    };
    const showToastWithNewAnimation = (id, alertProps) => {
        dispatch({
            type: Action.UPDATE_TOAST,
            alertProps: { ...alertProps, isVisible: false },
            id: '',
        });
        setTimeout(() => {
            dispatch({
                type: Action.UPDATE_TOAST,
                alertProps,
                id: alertProps.isVisible ? id : '',
            });
        });
    };
    const updateToastAlert = (id, alertProps) => {
        const shouldRefreshToastAnimation = alertProps.isVisible &&
            state.toastAlertProps.isVisible &&
            state.toastAlertProps.message !== alertProps.message &&
            alertProps.shouldRefreshToastAnimation;
        if (shouldRefreshToastAnimation) {
            if (state.currentToastId &&
                state.currentToastId !== id &&
                state.toastAlertProps.onClose) {
                state.toastAlertProps.onClose();
            }
            showToastWithNewAnimation(id, alertProps);
        }
        else {
            dispatch({
                type: Action.UPDATE_TOAST,
                alertProps,
                id: alertProps.isVisible ? id : '',
            });
        }
    };
    const contextValue = {
        updateBannerAlert,
        updateToastAlert,
    };
    let bannerAlertPortalContainer;
    if (customBannerAlertContainerId) {
        bannerAlertPortalContainer = document.getElementById(customBannerAlertContainerId);
    }
    else {
        bannerAlertPortalContainer = document.getElementById(V1_GLOBAL_ALERT_CONTAINER_ID);
        if (!bannerAlertPortalContainer) {
            bannerAlertPortalContainer = document.getElementById(GLOBAL_ALERT_CONTAINER_ID);
        }
    }
    const globalBannerAlert = bannerAlertPortalContainer
        ? ReactDOM.createPortal(React.createElement(Alert.Banner, { ...state.bannerAlertProps, "data-testid": GlobalAlertTestId.BANNER }), bannerAlertPortalContainer)
        : null;
    const globalToastAlert = ReactDOM.createPortal(React.createElement(Alert.Toast, { ...state.toastAlertProps, "data-testid": GlobalAlertTestId.TOAST }), document.body);
    useEffect(() => {
        return () => {
            if (!bannerAlertPortalContainer &&
                state.bannerAlertProps.isVisible) {
                logger.warn(`Banner alert is not shown because there is no container found. Looked for the following containers (in order of precedence):\n` +
                    `1. Custom container id: ${customBannerAlertContainerId}\n` +
                    `2. Container id in Blink v1 shell: ${V1_GLOBAL_ALERT_CONTAINER_ID}\n` +
                    `3, Container id in Blink v2 shell: ${GLOBAL_ALERT_CONTAINER_ID}\n`);
            }
        };
    });
    return (React.createElement(React.Fragment, null,
        globalBannerAlert,
        globalToastAlert,
        React.createElement(GlobalAlertContext.Provider, { value: contextValue }, children)));
};
//# sourceMappingURL=global-alert-context.js.map